// extracted by mini-css-extract-plugin
module.exports = {"spacerV":"spacer_spacerV__mJpqx"};